import { render, staticRenderFns } from "./TujuanPendaftaran.vue?vue&type=template&id=3ed03982&"
import script from "./TujuanPendaftaran.vue?vue&type=script&lang=js&"
export * from "./TujuanPendaftaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports